import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { PanelLeft } from "lucide-react";
import { Breadcrumb } from "./Breadcrumb";
import { HeaderActions } from "./HeaderActions";
import { UserRole } from "@/lib/auth-utils";

export interface Profile {
  id: string;
  given_name: string;
  family_name: string;
  role: UserRole;
}

interface PageHeaderProps {
  breadcrumbs: {
    title: string;
    href?: string;
  }[];
  className?: string;
  onMenuClick?: () => void;
}

export function PageHeader({
  breadcrumbs,
  className,
  onMenuClick
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "border-b px-4 py-2 flex items-center justify-between gap-4",
        className
      )}
    >
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuClick}
          className="text-muted-foreground hover:text-foreground flex-shrink-0"
        >
          <PanelLeft className="h-5 w-5" />
        </Button>
        <Breadcrumb
          items={breadcrumbs}
          className="overflow-x-auto no-scrollbar"
        />
      </div>
      <HeaderActions variant="avatar" className="pr-2 flex-shrink-0" />
    </div>
  );
}
